import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Register from './auth/Register';
import Login from './auth/Login';
import Dashboard from './Dashboard';
import Settings from './Settings';
import AcceptInvite from './AcceptInvite';
import UserManagement from './UserManagement';
import Layout from './Layout';
import Profile from './Profile';
import VatMappings from './VatMappings';
import { auth } from './firebase/config';
import { useEffect, useState } from 'react';
import { el } from './i18n/el';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = auth.onAuthStateChanged((firebaseUser) => {
      setUser(firebaseUser);
      setLoading(false);
    });
    return () => unsub();
  }, []);

  if (loading) return <p className="p-8 text-center text-gray-600">{el.appLoading}</p>;

  return (
    <Router>
      <Routes>
        {/* Deep links (e-mail) must work whether or not the user is signed in.
            Without this route in the authenticated branch, invite links could
            fall through to * and never load AcceptInvite. */}
        <Route path="/accept-invite" element={<AcceptInvite />} />
        {user ? (
          <Route path="/" element={<Layout />}>
            <Route index element={<Dashboard />} />
            <Route path="vat-mappings" element={<VatMappings />} />
            <Route path="settings" element={<Settings />} />
            <Route path="/users" element={<UserManagement />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Route>
        ) : (
          <>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="*" element={<Navigate to="/login" />} />
          </>
        )}
      </Routes>
    </Router>
  );
}

export default App;
